<template>
    <section id="agenda-page">
        <cm-back
            sectionTitle="Agenda Builder"
            :contentName="meetup ? meetup.name : 'Loading...'"
            :to="{name: 'manage', query: {view: 'meetups'}}"
        ></cm-back>
        <div class="agenda-wrapper">
            <section class="agenda-list">
                <p
                    class="text-lg-left"
                >Meetup time: {{meetupStartTime}} - {{meetupEndTime}} ({{meetupDuration}} minutes)</p>

                <div v-for="(entry, index) in agendaEntries" :key="index" class="agenda-entry">
                    <div class="side">
                        <div class="dot"></div>
                        <div class="line"></div>
                    </div>
                    <div class="entry-content">
                        <time class="entry-time">
                            <small>{{formatTime(entry.start, entry.end)}}</small>
                        </time>
                        <h6 v-if="entry.title" class="entry-title mt-2 mb-0">
                            <strong>{{entry.title}}</strong>
                        </h6>
                        <div class="entry-author h6" v-if="entry.authors && entry.authors.length">
                            <small>By {{entry.authors.filter(el => el.firstname && el.lastname).map(el => el.firstname + " " + el.lastname).join(", ")}}</small>
                        </div>
                        <p class="entry-text m-0">{{entry.description}}</p>
                        <div class="actions">
                            <i class="material-icons" @click="deleteEntry(index)">delete</i>
                            <i
                                class="material-icons"
                                v-if="entry.custom"
                                @click="editCustom(entry)"
                            >edit</i>
                            <i
                                class="material-icons-outlined"
                                v-if="!entry.custom"
                                @click="openInfoModal(entry.id)"
                            >info</i>
                        </div>
                    </div>
                </div>

                <drop
                    class="dropzone"
                    @dragover="hovering = true"
                    @drop="hovering = false; addPaper(JSON.parse(arguments[0]['text/plain']))"
                    @dragleave="hovering = false"
                    :class="{dragging: dragging, hovering: hovering}"
                >
                    <div v-show="!dragging">
                        <a
                            href
                            class="d-lg-none"
                            @click.prevent="paperAdd = true"
                        >Add speaker session</a>
                        <span class="d-none d-lg-inline">Drag and drop a paper here</span>
                        <br />
                        <small>or</small>
                        <br />
                        <a href @click.prevent="customAdd = true">Add custom session</a>
                    </div>
                    <div v-show="dragging">
                        <h4>Drop here to add</h4>
                    </div>
                </drop>
                <div>
                    <div class="mt-3">
                        <md-radio v-model="visibility" :value="1">
                            Agenda is
                            <strong>visible</strong> on meetup's detail page
                        </md-radio>
                        <br />
                        <md-radio v-model="visibility" :value="0">
                            Agenda is
                            <strong>not visible</strong> on meetup's detail page
                        </md-radio>
                    </div>
                    <hr class="w-100 mobile-no" />
                    <div class="w-100 d-flex justify-content-end mobile-no">
                        <button
                            class="btn btn-primary align-items-center justify-content-center d-none d-lg-flex"
                            :disabled="!dirty || saving"
                            @click="saveAgenda"
                        >
                            <b-spinner v-if="saving" small variant="light" class="mr-2"></b-spinner>save agenda
                        </button>
                    </div>
                </div>
            </section>
            <aside class="aside-papers-list mobile-no">
                <h5>Approved papers:</h5>
                <small v-if="papers.length">Drag papers into agenda</small>
                <div
                    v-if="loadingPapers"
                    class="w-100 p-3 d-flex justify-content-center align-items-center"
                >
                    <b-spinner></b-spinner>
                </div>
                <div class="scrollable" v-if="papers.length">
                    <drag
                        :draggable="!checkDisabled(paper.id)"
                        @dragenter="dragging = true"
                        @dragend="dragging = false"
                        v-for="paper in papers"
                        :key="paper.id"
                        class="paper-draggable"
                        :class="{disabled: checkDisabled(paper.id)}"
                        :transfer-data="{'text/plain' : JSON.stringify(paper)}"
                    >
                        <div class="d-flex align-items-center justify-content-between">
                            <!-- <img :src="paper.speaker_photo_url" /> -->
                            <div class="duration">{{paper.duration}}'</div>
                            <span class="paper-infos">
                                <div>{{paper.speaker_firstname}} {{paper.speaker_lastname}}</div>
                                <div class="text-muted">{{paper.title}}</div>
                            </span>
                            <i class="material-icons" @click="addPaper(paper)">add</i>
                            <i class="material-icons-outlined" @click="openInfoModal(paper.id)">info</i>
                        </div>
                    </drag>
                </div>
                <div v-else-if="!loadingPapers" class="text-muted">
                    There are no accepted papers on this meetup.
                    <br />
                    <router-link
                        v-if="meetup && meetup.cfp_slug"
                        :to="{name: 'manage-submissions', params: {...$route.params}}"
                    >Choose them from submissions' list</router-link>
                    <router-link
                        v-else
                        :to="{name: 'meetup-edit', params: {...$route.params}, query: {cfp: 'true'}}"
                    >Open a Call for Speakers for this meetup!</router-link>
                </div>
            </aside>
        </div>
        <md-dialog :md-active.sync="paperAdd" class="paper-session-modal">
            <md-dialog-title>
                Add speaker session
                <i class="material-icons close" @click="paperAdd = false">close</i>
            </md-dialog-title>
            <md-dialog-content>
                <div
                    v-for="paper in papers"
                    :key="paper.id"
                    class="paper-draggable"
                    :class="{disabled: checkDisabled(paper.id)}"
                >
                    <div class="d-flex align-items-center justify-content-between">
                        <!-- <img :src="paper.speaker_photo_url" /> -->
                        <div class="duration">{{paper.duration}}'</div>
                        <span class="paper-infos">
                            <div>{{paper.speaker_firstname}} {{paper.speaker_lastname}}</div>
                            <div class="text-muted">{{paper.title}}</div>
                        </span>
                        <i class="material-icons" @click="addPaper(paper); paperAdd = false">add</i>
                        <i class="material-icons-outlined" @click="openInfoModal(paper.id)">info</i>
                    </div>
                </div>
                <div v-if="!papers.length" class="p-3 text-muted">There are no papers to add.</div>
            </md-dialog-content>
            <!-- <md-dialog-actions>
                <md-button class="btn btn-outline-success" @click="paperAdd = false">Close</md-button>
            </md-dialog-actions>-->
        </md-dialog>
        <md-dialog
            :md-active.sync="customAdd"
            class="custom-session-modal"
            @md-closed="isEdit = false"
        >
            <md-dialog-title>
                Add custom session
                <i class="material-icons close" @click="customAdd = false">close</i>
            </md-dialog-title>
            <md-dialog-content>
                <div class="d-flex justify-content-between flex-wrap">
                    <timepicker
                        v-model="session.start"
                        class="mr-sm-2"
                        :class="getValidationClass('start')"
                        label="Start time*"
                        :scope="[meetupStartTime, meetupEndTime]"
                    >
                        <span
                            class="md-error"
                            v-if="!$v.session.start.required"
                        >Start time is required</span>
                        <span
                            class="md-error"
                            v-if="!checkTimes"
                        >Start time must be set before end time</span>
                    </timepicker>

                    <timepicker
                        v-model="session.end"
                        class="ml-sm-2"
                        :class="getValidationClass('end')"
                        label="End time*"
                        :scope="[meetupStartTime, meetupEndTime]"
                    >
                        <span class="md-error" v-if="!$v.session.end.required">End time is required</span>
                        <span
                            class="md-error"
                            v-if="!checkTimes"
                        >End time must be set after start time</span>
                    </timepicker>
                </div>
                <md-field :class="getValidationClass('title')">
                    <label for="title">Title*</label>
                    <md-input id="title" v-model="session.title" maxlength="120"></md-input>
                    <span class="md-error" v-if="!$v.session.title.required">Title is required</span>
                </md-field>
                <md-field>
                    <label for="description">Description</label>
                    <md-textarea id="description" v-model="session.description" maxlength="600"></md-textarea>
                </md-field>
            </md-dialog-content>
            <div class="d-flex justify-content-end p-2 align-items-center">
                <button class="btn btn-outline-success mr-2" @click="customAdd = false">Cancel</button>
                <button class="btn btn-primary" @click="addCustomEntry">{{isEdit ? "Edit" : "Add"}}</button>
            </div>
        </md-dialog>
        <md-dialog-alert :md-content="resultText" :md-active.sync="resultModal" md-title="Result"></md-dialog-alert>
        <paper-info-modal
            :key="paperInfoKey"
            :agenda="paperAdd"
            v-model="showPaperInfo"
            :currentPaper="currentPaper"
        ></paper-info-modal>
        <div class="floating-button d-flex d-lg-none">
            <button
                class="btn btn-primary w-100 align-items-center justify-content-center d-lg-none d-flex"
                :disabled="!dirty || saving"
                @click="saveAgenda"
            >
                <b-spinner v-if="saving" small variant="light" class="mr-2"></b-spinner>save agenda
            </button>
        </div>
    </section>
</template>
<script>
import { Drag, Drop } from "vue-drag-drop";
import { format, differenceInMinutes, parseISO } from "date-fns";
import Timepicker from "@/components/Communities/Timepicker";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import PaperInfoModal from "@/components/Papers/PaperInfoModal";
import CmBack from "@/components/CmBack";
export default {
    name: "AgendaBuilder",
    components: {
        Drag,
        Drop,
        Timepicker,
        PaperInfoModal,
        CmBack
    },
    mixins: [validationMixin],
    data: () => ({
        dirty: false,
        saving: false,
        customAdd: false,
        currentPaper: null,
        showPaperInfo: false,
        paperInfoKey: 0,
        resultModal: false,
        resultText: "",
        visibility: null,
        paperAdd: false,
        session: {
            id: null,
            custom: null,
            start: "",
            end: "",
            title: "",
            description: ""
        },
        isEdit: false,
        agendaEntries: [],
        loadingPapers: false,
        dragging: false,
        hovering: false,
        papers: [],
        disabledList: []
    }),
    validations: {
        session: {
            start: {
                required
            },
            end: {
                required
            },
            title: {
                required
            }
        }
    },
    watch: {
        customAdd(val) {
            if (val) {
                this.session.start =
                    this.agendaEntries.length && !this.isEdit
                        ? this.agendaEntries[this.agendaEntries.length - 1].end
                        : this.meetupStartTime;
            } else {
                this.$v.$reset();
                this.session = {
                    custom: null,
                    start: "",
                    end: "",
                    title: "",
                    description: ""
                };
            }
        },
        visibility(val, oldVal) {
            if (oldVal !== null) this.dirty = true;
        }
    },
    computed: {
        meetup() {
            return this.$store.getters.meetup;
        },
        community() {
            return this.$store.getters.community;
        },
        meetupStartTime() {
            if (this.meetup) {
                const temp = parseISO(this.meetup.start_datetime + "Z");
                return format(temp, "HH:mm");
            } else return "";
        },
        meetupEndTime() {
            if (this.meetup) {
                const temp = parseISO(this.meetup.end_datetime + "Z");
                return format(temp, "HH:mm");
            } else return "";
        },
        checkTimes() {
            if (this.session.start && this.session.end) {
                return this.session.start < this.session.end;
            } else {
                return true;
            }
        },
        meetupDuration() {
            if (this.meetup) {
                return differenceInMinutes(
                    parseISO(this.meetup.end_datetime),
                    parseISO(this.meetup.start_datetime)
                );
            } else return "";
        }
    },
    async mounted() {
        this.loadingPapers = true;

        if (!this.meetup) {
            try {
                const community = await this.$communityApi.getCommunity(
                    this.$route.params.id
                );
                this.$store.commit("setCommunity", community);
            } catch (error) {
                console.error(error);
                this.$router.push("/communities#management");
                return;
            }
            try {
                const meetup = await this.$meetupApi.getMeetupById(
                    this.$route.params.meetupid
                );
                this.$store.commit("setMeetup", meetup.data);
            } catch (error) {
                console.error(error);
            }
        }
        if (this.meetup.cfp_slug) {
            try {
                const papersData = await this.$meetupApi.getMeetupProposals(
                    this.$route.params.meetupid,
                    1,
                    10,
                    "APPROVED"
                );
                this.papersTotal = papersData.total;
                this.papers = papersData.data;
            } catch (error) {
                console.error(error);
            }
            this.loadingPapers = false;
        } else {
            this.loadingPapers = false;
        }
        if (this.meetup.schedule) {
            this.agendaEntries = JSON.parse(this.meetup.schedule);
            if (this.papers.length) {
                this.agendaEntries.forEach(el => {
                    this.papers.forEach(paper => {
                        if (paper.id === el.id) {
                            this.disabledList.push(paper.id);
                        }
                    });
                });
            }
        } else {
            this.agendaEntries.push({
                id: 0,
                custom: true,
                start: this.meetupStartTime,
                end: this.addMinutes(this.meetupStartTime, 15),
                title: "Introduction",
                description: "This is a custom field you can edit."
            });
        }
        this.visibility =
            typeof this.meetup.schedule_visibility === "number"
                ? this.meetup.schedule_visibility
                : 0;
    },
    methods: {
        async saveAgenda() {
            const agenda = this.agendaEntries.length
                ? JSON.stringify(this.agendaEntries)
                : "";
            try {
                this.saving = true;
                await this.$meetupApi.updateMeetup({
                    id: this.meetup.id,
                    schedule: agenda,
                    schedule_visibility: this.visibility
                });
                this.resultText = "Agenda successfully saved!";
                this.dirty = false;
            } catch (error) {
                console.error(error);
                this.resultText = error.message;
            } finally {
                this.resultModal = true;
                this.saving = false;
            }
        },
        openInfoModal(id) {
            this.currentPaper = this.papers.find(el => el.id === id);
            this.paperInfoKey++;
            this.showPaperInfo = true;
        },
        getValidationClass(fieldName) {
            const field = this.$v.session[fieldName];
            if (field) {
                return {
                    "md-invalid":
                        (field.$invalid || !this.checkTimes) && field.$dirty
                };
            }
        },
        addCustomEntry() {
            this.$v.$touch();
            if (this.$v.$invalid) return;
            this.dirty = true;
            this.session.custom = true;
            this.session.id = this.isEdit
                ? this.session.id
                : this.agendaEntries.length;
            this.agendaEntries[this.findEntryIndex(this.session.id)] = {
                ...this.session
            };
            this.session = {
                custom: null,
                start: "",
                end: "",
                title: "",
                description: ""
            };
            this.isEdit = false;
            this.customAdd = false;
            this.agendaEntries.sort((a, b) => {
                if (a.start < b.start) {
                    return -1;
                }
                return 1;
            });
        },
        findEntryIndex(id) {
            if (this.isEdit) {
                return this.agendaEntries.findIndex(el => el.id === id);
            } else {
                return this.agendaEntries.length;
            }
        },
        deleteEntry(index) {
            if (typeof this.agendaEntries[index].id !== "number") {
                this.disabledList.splice(
                    this.disabledList.indexOf(this.agendaEntries[index].id),
                    1
                );
            }
            this.dirty = true;
            this.agendaEntries.splice(index, 1);
        },
        editCustom(entry) {
            this.isEdit = true;
            this.session = { ...entry };
            this.customAdd = true;
            this.dirty = true;
        },
        formatTime(start, end) {
            return start + "/" + end;
        },
        formatAuthors(authors) {
            return authors
                .map(
                    (el, i) =>
                        (authors.length > 1 ? " " : "") +
                        el.firstname +
                        " " +
                        el.lastname
                )
                .toString();
        },
        checkDisabled(id) {
            return ~this.disabledList.indexOf(id);
        },
        addPaper(paper) {
            const start = this.agendaEntries.length
                ? this.agendaEntries[this.agendaEntries.length - 1].end
                : this.meetupStartTime;
            const authors = [
                {
                    firstname: paper.speaker_firstname,
                    lastname: paper.speaker_lastname
                }
            ];
            if (paper.cospeakers && paper.cospeakers.length) {
                authors.push(
                    ...paper.cospeakers.map(el => ({
                        firstname: el.first_name,
                        lastname: el.last_name
                    }))
                );
            }
            this.dirty = true;
            this.disabledList.push(paper.id);
            this.agendaEntries.push({
                id: paper.id,
                custom: false,
                start: start,
                end: this.addMinutes(start, paper.duration),
                title: paper.title,
                description: paper.abstract,
                authors: authors
            });
        },
        addMinutes(time, minsToAdd) {
            function D(J) {
                return (J < 10 ? "0" : "") + J;
            }
            var piece = time.split(":");
            var mins = piece[0] * 60 + +piece[1] + +minsToAdd;
            return D(((mins % (24 * 60)) / 60) | 0) + ":" + D(mins % 60);
        }
    }
};
</script>
<style lang="scss">
// .content-section {
//     background: #f8f8f8;
// }
.md-menu-content {
    z-index: 5000 !important;
}
.agenda-wrapper {
    .md-radio-label {
        height: auto;
        color: #0d1d30 !important;
    }
}
</style>
<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
.custom-session-modal {
    .md-dialog-content {
        max-width: 100%;
    }
    @media all and (min-width: $size-tablet-portrait) {
        min-width: 460px;
        .md-autocomplete {
            width: 48%;
        }
    }
}

#agenda-page {
    height: 100%;
}
.agenda-wrapper {
    color: $palette-blue;
    max-width: 1440px;
    min-height: calc(100vh - 231px);

    height: 100%;
    margin: 0 auto;
    display: flex;
    @media all and (min-width: $size-tablet-landscape) {
        padding: 0 15px;
    }
    .md-radio {
        margin: 3px 0;
        font-size: 0.9rem;
    }
    .agenda-list {
        padding: 15px;
        width: 100%;
        @media all and (min-width: $size-tablet-landscape) {
            width: 70%;
        }

        .agenda-entry {
            position: relative;
            padding-left: 25px;

            .side {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 20px;
                position: absolute;
                height: 100%;
                left: 0;
                top: 10px;

                .dot {
                    border-radius: 50%;
                    background: #b3b3b3;
                    width: 10px;
                    height: 15px;
                    margin: 0;
                }
                .line {
                    height: 100%;
                    background: #e5e5e5;
                    width: 4px;
                    border-radius: 10.5px;
                    margin: 8px 0;
                }
            }

            .entry-content {
                padding: 5px 10px 10px;
                .entry-title {
                    padding-right: 80px;
                }
                transition: all 0.5s ease;
                .actions {
                    position: absolute;
                    right: 0;
                    top: 10px;
                    transition: all 0.5s ease;
                    @media all and (min-width: $size-tablet-landscape) {
                        opacity: 0;
                        right: -24px;
                    }
                    i {
                        transition: all 0.5s ease;
                        padding: 5px;
                        margin: 0 3px;
                        background: #f8f8f8;
                        border-radius: 50%;
                        color: $palette-orange;
                        cursor: pointer;
                        &:hover {
                            background: #eaeaea;
                        }
                    }
                }
                &:hover {
                    border-radius: 2px;
                    box-shadow: 0 2px 4px 0 rgba(226, 226, 226, 0.5);
                    background: white;
                    .actions {
                        right: 10px;
                        opacity: 1;
                    }
                }
            }

            .entry-time {
                font-size: 16px;
                color: #0e1e30;
                font-weight: 600;
            }
        }
    }
    .aside-papers-list {
        background: #f8f8f8;
        background: rgb(2, 0, 36);
        background: linear-gradient(
            0deg,
            rgba(2, 0, 36, 0) 0%,
            rgba(248, 248, 248, 1) 40%
        );
        width: 100%;
        padding: 15px;
        min-height: calc(100vh - 231px);
        height: 100%;
        display: flex;
        flex-direction: column;
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+85,f8f8f8+100 */
        background: #ffffff; /* Old browsers */
        background: -moz-linear-gradient(
            top,
            #ffffff 85%,
            #f8f8f8 100%
        ); /* FF3.6-15 */
        background: -webkit-linear-gradient(
            top,
            #ffffff 85%,
            #f8f8f8 100%
        ); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(
            to bottom,
            #ffffff 85%,
            #f8f8f8 100%
        ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f8f8f8',GradientType=0 ); /* IE6-9 */
        .scrollable {
            max-height: 320px;
            overflow-y: auto;
        }

        @media all and (min-width: $size-tablet-landscape) {
            position: sticky;
            top: 118px;
            width: 30%;
            .scrollable {
                max-height: 600px;
            }
        }
    }

    .dropzone {
        padding: 15px;
        border: 1px dashed #b3b3b3;
        border-radius: 5px;
        text-align: center;
        color: gray;
        margin-top: 30px;
        transition: all 0.5s ease;
        min-height: 110px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        &.dragging {
            border-color: $palette-orange;
        }
        &.hovering {
            background: #ff5c0010;
        }

        @media all and (min-width: $size-tablet-landscape) {
            margin-left: 25px;
        }
    }
}
.paper-draggable {
    padding: 5px;
    border: 1px solid #eaeaea;
    margin: 5px 0;
    border-radius: 5px;
    @media all and (min-width: $size-tablet-landscape) {
        padding: 10px;
        &:hover {
            box-shadow: 0 2px 4px 0 rgba(226, 226, 226, 0.5);
            border: solid 1px #dbdbdb;
            cursor: move;
        }
    }
    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        i {
            visibility: hidden;
        }
    }
    img {
        width: 12%;
        border-radius: 50%;
        margin-right: 15px;
    }
    .duration {
        border-radius: 50%;
        width: 36px;
        height: 36px;
        border: 2px solid #eaeaea;
        color: $palette-blue;
        font-weight: bold;
        font-size: 12px;
        padding: 7px 5px;
        margin-right: 10px;
        text-align: center;
    }
    .paper-infos {
        font-size: 0.8rem;
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: 60%;
    }
    i {
        background: #f8f8f8;
        color: $palette-orange;
        padding: 5px;
        border-radius: 50%;
        margin: 0 3px;
        cursor: pointer;
        transition: all 0.5s ease;
        &:hover {
            background: #eaeaea;
        }
    }
}
.floating-button {
    position: sticky;
    bottom: 0px;
    display: flex;
    align-items: center;
    width: 100%;
    height: auto;
    z-index: 5;
    background: #f8f8f8;
    button {
        margin: 15px;
    }
}
</style>